import { useLayout } from '@hana/shell';
import { TasksCompact } from './TasksCompact';
import { TasksScreen } from './TasksScreen';

/** iPad / điện thoại dùng bản compact (Mint-Tasks-iPad, -Phone); desktop giữ nguyên. */
export function TasksRoute() {
  const layout = useLayout();
  return layout === 'pad' || layout === 'phone' ? <TasksCompact phone={layout === 'phone'} /> : <TasksScreen />;
}
